import { useEffect, useState } from "react";
import { Form } from "react-final-form";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import arrayMutators from "final-form-arrays";
import { Loading } from "../loading";
import { AlertCustom } from "../../components/AlertMui";
import { LayoutMobi } from "../../components/Layout";
import { FieldArray } from "react-final-form-arrays";
import CardProcesosMobi from "./components/cardProcesosMobi";
import {
  useListUbicationProvider,
  useProcesos,
  useProcesosTipoId,
} from "../../hooks/useProducts";
import ReactPaginate from "react-paginate";
import { IsMobi } from "../../hooks/isMobi";
import { InputNotForm } from "../../components/Input";
import Button from "../../components/Button";
import { DialogGen } from "../../components/Dialog";
import CardNewProcesosMobi from "./components/cardNewProcesoMobi";
import UpdateAreaProcesoProductivo from "../procesosProductivos/components/updateAreaProcesoProductivo";
const ProcesosProductivos = () => {
  const [alertCustom, setAlertCustom] = useState({
    open: false,
    title: "",
    severity: "",
    message: "",
  });
  const [pageSelected, setPageSelected] = useState(0);
  const [currentItems, setCurrentItems] = useState(null);
  const itemsPerPage = 8;
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const {
    data: procesosTipoId,
    isLoading: isLoadingProcesosTipoId,
    isError: isErrorProcesosTipoId,
    refetch: RefetchProcesosTipoId,
  } = useProcesosTipoId();
  const {
    data: listUbicationProvider,
    isLoading: isLoadingListUbicationProvider,
    isError: isErrorListUbicationProvider,
  } = useListUbicationProvider(0);
  const {
    data: procesos,
    isLoading: isLoadingProcesos,
    isError: isErrorProcesos,
    refetch,
  } = useProcesos();
  const [expanded, setExpanded] = useState(null);
  const [modalNewProceso, setModalNewProceso] = useState(false);
  const [modalUpdateAreaProceso, setModalUpdateAreaProceso] = useState(false);
  const [radioButton, setRadioButton] = useState("1");
  const [initialValue, setInitialValue] = useState({
    datos: [],
  });
  const [dataFilter, setDataFilter] = useState([]);
  const [search, setSearch] = useState(null);
  useEffect(() => {
    if (
      !!procesos &&
      !!procesosTipoId &&
      procesosTipoId?.length > 0 &&
      procesos?.length > 0
    ) {
      setInitialValue({
        datos: procesos
          .map((item) => {
            return {
              ...item,
              procesoProductivoTipoId: procesosTipoId?.find(
                (x) =>
                  x?.procesoProductivoTipoDescripcion ===
                  item?.procesoProductivoTipoDescripcion
              ).procesoProductivoTipoId,
            };
          })
          .filter((item) => item?.procesoProductivoActivo === radioButton),
      });
    }
  }, [procesos, procesosTipoId, radioButton]);
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems({
      datos: !!search
        ? dataFilter.slice(itemOffset, endOffset)
        : initialValue.datos.slice(itemOffset, endOffset),
    });

    setPageCount(
      Math.ceil(
        (!!search ? dataFilter.length : initialValue.datos.length) /
          itemsPerPage
      )
    );
  }, [itemOffset, itemsPerPage, initialValue, search, dataFilter]);
  if (
    isLoadingProcesos ||
    isLoadingProcesosTipoId ||
    isLoadingListUbicationProvider
  ) {
    return <Loading />;
  }
  if (
    !Array.isArray(procesos) ||
    !Array.isArray(procesosTipoId) ||
    !Array.isArray(listUbicationProvider) ||
    isErrorProcesos ||
    isErrorProcesosTipoId ||
    isErrorListUbicationProvider
  ) {
    return (
      <LayoutMobi title={"Hubo un Error"}>
        <Box>
          <Typography variant="h3">
            Nos apena informate que ha ocurrido un error que debemos revisar
          </Typography>
        </Box>
      </LayoutMobi>
    );
  }

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % initialValue.datos.length;
    setPageSelected(event.selected);
    setItemOffset(newOffset);
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const changeSearch = (evt) => {
    setSearch(evt.target.value ? evt.target.value : null);
    setItemOffset(0);
    setPageSelected(0);
    if (evt.target.value !== "") {
      setDataFilter(
        initialValue.datos.filter((item) =>
          Object.values(item).find(
            (valor) =>
              !!valor &&
              valor
                .toString()
                .toUpperCase()
                .includes(evt.target.value.toUpperCase())
          )
        )
      );
    } else {
      setDataFilter([]);
    }
  };
  const changeRadioButton = (valor) => {
    setRadioButton(valor);
  };

  return (
    <>
      <LayoutMobi title="Listado de procesos" href={"/Ajustes"} sx={{ p: 2 }}>
        <Form
          onSubmit={(values) => {}}
          initialValues={currentItems}
          mutators={{
            ...arrayMutators,
          }}
          validate={(values) => {
            return {};
          }}
          render={({
            handleSubmit,
            form: {
              mutators: { push },
              restart,
            },
            submitting,
            pristine,
            values,
          }) => {
            return (
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "end",
                    backgroundColor: "#fafafa",
                    mb: 2,
                  }}
                >
                  <Button
                    label={"Agregar nuevo proceso productivo"}
                    onClick={() => setModalNewProceso(true)}
                  />
                  <Button
                    label={"Modificar área"}
                    onClick={() => setModalUpdateAreaProceso(true)}
                    sx={{ mt: 1 }}
                  />
                </Box>
                <FormControl
                  sx={{ display: "flex", justifyContent: "center", mb: 1 }}
                >
                  <FormLabel sx={{ display: "flex", justifyContent: "center" }}>
                    Mostrar
                  </FormLabel>
                  <RadioGroup
                    defaultValue="1"
                    onChange={(evt) => changeRadioButton(evt.target.value)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Activos"
                      />

                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="Inactivos"
                      />
                    </Box>
                  </RadioGroup>
                </FormControl>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fafafa",
                    mb: 2,
                  }}
                >
                  <InputNotForm
                    onchange={(evt) => changeSearch(evt)}
                    label="Buscar"
                  />
                </Box>

                <FieldArray name="datos">
                  {({ fields }) =>
                    fields.map((name, index) => (
                      <Accordion
                        expanded={expanded === `panel${index}`}
                        onChange={handleChange(`panel${index}`)}
                        onClick={() => {}}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="body2">
                            {`${
                              values.datos[index]
                                .procesoProductivoTipoDescripcion
                            } ${
                              values.datos[index]
                                .procesoProductivoTipoDescripcion !== "-"
                                ? "-"
                                : ""
                            }
                          ${
                            !!values.datos[index]
                              .procesoProductivoDescripcion ||
                            values.datos[index].procesoProductivoDescripcion ===
                              "-"
                              ? `${values.datos[index].procesoProductivoDescripcion}`
                              : ""
                          }`}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            border: "1px solid #C1C1C1",
                            boxShadow: "1px 1px 1px 1px rgba(0,0,0, 0.05)",
                          }}
                        >
                          <CardProcesosMobi
                            name={name}
                            procesosTipoId={procesosTipoId}
                            listUbicationProvider={listUbicationProvider}
                            procesoProductivoId={
                              values.datos[index].procesoProductivoId
                            }
                            values={values}
                            index={index}
                            refetch={refetch}
                            setAlertCustom={setAlertCustom}
                          />
                        </AccordionDetails>
                      </Accordion>
                    ))
                  }
                </FieldArray>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <ReactPaginate
                    nextLabel="Siguiente >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={IsMobi() ? 2 : 5}
                    pageCount={pageCount}
                    forcePage={pageSelected}
                    previousLabel="< Anterior"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </Box>
              </Box>
            );
          }}
        />
        <DialogGen
          open={modalNewProceso}
          title={"Agregar proceso productivo"}
          onClick={() => setModalNewProceso(false)}
          sx={{ width: "90%" }}
        >
          <CardNewProcesosMobi
            procesosTipoId={procesosTipoId}
            listUbicationProvider={listUbicationProvider}
            refetch={refetch}
            setAlertCustom={setAlertCustom}
            setModalNewProceso={setModalNewProceso}
          />
        </DialogGen>
        <DialogGen
          open={modalUpdateAreaProceso}
          title={"Área proceso productivo"}
          onClick={() => setModalUpdateAreaProceso(false)}
          sx={{ maxWidth: "500px" }}
        >
          <UpdateAreaProcesoProductivo
            procesosTipoId={procesosTipoId}
            setAlertCustom={setAlertCustom}
            RefetchProcesosTipoId={RefetchProcesosTipoId}
          />
        </DialogGen>
      </LayoutMobi>
      <AlertCustom
        open={alertCustom.open}
        title={alertCustom.title}
        message={alertCustom.message}
        severity={alertCustom.severity}
        onclick={() =>
          setAlertCustom({
            open: false,
            title: "",
            severity: "",
            message: "",
          })
        }
      />
    </>
  );
};
export default ProcesosProductivos;
